import { render } from "./login.vue?vue&type=template&id=3cffc361"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
script.render = render

export default script